import { createSlice } from '@reduxjs/toolkit';

const MAX_PRICE_DATA_LENGTH = 100;

const initialState = {
  tokenData: {}
};

const marketDataSlice = createSlice({
  name: 'marketData',
  initialState,
  reducers: {
    updateTokenPriceData: (state, action) => {
      const { token, data } = action.payload;

      if (!Array.isArray(data) || data.length === 0) return;

      if (!state.tokenData[token]) {
        state.tokenData[token] = { priceData: [], macdHistogram: [] };
      }

      const priceArr = state.tokenData[token].priceData;
      priceArr.push(...data);

      if (priceArr.length > MAX_PRICE_DATA_LENGTH) {
        priceArr.splice(0, priceArr.length - MAX_PRICE_DATA_LENGTH);
      }
    },

    // reducer for batched price updates
    updateMultipleTokenPrices: (state, action) => {
      const tokenBatch = action.payload;
      console.log("tokenBatch",tokenBatch);
      console.log("Dispatching token update:", Object.keys(tokenBatch), "Ticks per token:", Object.entries(tokenBatch).map(([t, d]) => `${t}: ${d.length}`));

      for (const token in tokenBatch) {
        const data = tokenBatch[token];
        if (!Array.isArray(data) || data.length === 0) continue;

        if (!state.tokenData[token]) {
          state.tokenData[token] = { priceData: [], macdHistogram: [] };
        }

        const priceArr = state.tokenData[token].priceData;
        priceArr.push(...data);

        if (priceArr.length > MAX_PRICE_DATA_LENGTH) {
          priceArr.splice(0, priceArr.length - MAX_PRICE_DATA_LENGTH);
        }
      }
    },

    updateMACDHistogram: (state, action) => {
      const { token, data } = action.payload;

      if (!state.tokenData[token]) {
        state.tokenData[token] = { priceData: [], macdHistogram: [] };
      }

      if (Array.isArray(data) && data.length > 0) {
        state.tokenData[token].macdHistogram = data;
      }
    }
  }
});

export const {
  updateTokenPriceData,
  updateMultipleTokenPrices,
  updateMACDHistogram
} = marketDataSlice.actions;

export default marketDataSlice.reducer;
